import PaymentFailed from "@/components/payment-failed";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/payment-failed")({
  component: RouteComponent,
});

function RouteComponent() {
  return <PaymentFailed />;
}
